var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"route-stack"},[_c('keep-alive',[(_vm.showTabRootView)?_c('router-view'):_vm._e()],1),_c('keep-alive',{attrs:{"include":"AddMeetingRoom,selectMeetingRoomTimeSlot"}},[(_vm.showSecondaryView)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }